import classNames from 'classnames';
import { Button, Icon } from 'Components';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import './MenuOptions.css';


const MenuOptions = (props) => {
  const menuOptions = props.menuOptions.map(options => ({
    ...options,
    label: i18n.t(`menuOptions:${options.label}`),
  }));

  return (
    <div
      className={classNames('menu-options', {
      'menu-options--to-left': props.position === 'toLeft',
    })}
    >
      { menuOptions.map(options => (
        <Button key={options.label} onClick={() => props.onOptionClick(options.code)}>
          <Icon icon={options.icon} />
          <div>{options.label}</div>
        </Button>
    ))}
    </div>
  );
};

MenuOptions.propTypes = {
  menuOptions: PropTypes.arrayOf(PropTypes.shape({})),
  onOptionClick: PropTypes.func,
  position: PropTypes.string,
};

export default MenuOptions;



// WEBPACK FOOTER //
// ./src/components/MenuOptions/MenuOptions.jsx